import React from 'react';
import styles from "./HomePage.module.css"

import HomeSidebar from '../HomeSidebar/HomeSidebar';
import Banner from "./Banner/Banner"
import RecentDesigns from './RecentDesigns/RecentDesigns';
import PopularBackgrounds from './PopularBackgrounds/PopularBackgrounds';

export default function HomePage(props) {
  return (
    <section className={styles.homePage}>
      <HomeSidebar selectedOption="home" />

      <div className={styles.sections}>
        <Banner />
        
        <RecentDesigns setIsDesigning={props.setIsDesigning} />
        {/* <PopularBackgrounds /> */}
      </div>
    </section>
  );
}
